/* tslint:disable */
/* eslint-disable */
/**
 * RX360-WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FileSchemaIn } from './FileSchemaIn';
import {
    FileSchemaInFromJSON,
    FileSchemaInFromJSONTyped,
    FileSchemaInToJSON,
} from './FileSchemaIn';
import type { GovernorateEnum } from './GovernorateEnum';
import {
    GovernorateEnumFromJSON,
    GovernorateEnumFromJSONTyped,
    GovernorateEnumToJSON,
} from './GovernorateEnum';

/**
 * 
 * @export
 * @interface DoctorSignupStep4
 */
export interface DoctorSignupStep4 {
    /**
     * 
     * @type {FileSchemaIn}
     * @memberof DoctorSignupStep4
     */
    clinicLicensePhoto?: FileSchemaIn;
    /**
     * 
     * @type {GovernorateEnum}
     * @memberof DoctorSignupStep4
     */
    governorate?: GovernorateEnum;
    /**
     * 
     * @type {string}
     * @memberof DoctorSignupStep4
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof DoctorSignupStep4
     */
    clinicLicenseNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof DoctorSignupStep4
     */
    taxNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof DoctorSignupStep4
     */
    phoneNumber1?: string;
    /**
     * 
     * @type {string}
     * @memberof DoctorSignupStep4
     */
    phoneNumber2?: string;
}

/**
 * Check if a given object implements the DoctorSignupStep4 interface.
 */
export function instanceOfDoctorSignupStep4(value: object): boolean {
    return true;
}

export function DoctorSignupStep4FromJSON(json: any): DoctorSignupStep4 {
    return DoctorSignupStep4FromJSONTyped(json, false);
}

export function DoctorSignupStep4FromJSONTyped(json: any, ignoreDiscriminator: boolean): DoctorSignupStep4 {
    if (json == null) {
        return json;
    }
    return {
        
        'clinicLicensePhoto': json['clinic_license_photo'] == null ? undefined : FileSchemaInFromJSON(json['clinic_license_photo']),
        'governorate': json['governorate'] == null ? undefined : GovernorateEnumFromJSON(json['governorate']),
        'address': json['address'] == null ? undefined : json['address'],
        'clinicLicenseNumber': json['clinic_license_number'] == null ? undefined : json['clinic_license_number'],
        'taxNumber': json['tax_number'] == null ? undefined : json['tax_number'],
        'phoneNumber1': json['phone_number1'] == null ? undefined : json['phone_number1'],
        'phoneNumber2': json['phone_number2'] == null ? undefined : json['phone_number2'],
    };
}

export function DoctorSignupStep4ToJSON(value?: DoctorSignupStep4 | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'clinic_license_photo': FileSchemaInToJSON(value['clinicLicensePhoto']),
        'governorate': GovernorateEnumToJSON(value['governorate']),
        'address': value['address'],
        'clinic_license_number': value['clinicLicenseNumber'],
        'tax_number': value['taxNumber'],
        'phone_number1': value['phoneNumber1'],
        'phone_number2': value['phoneNumber2'],
    };
}

